export default "__VITE_ASSET__B69R80dz__"